<app-modal
  [title]="'Summary'| trans:'cart/summary-modal/title.Text'"
  [maxWidth]="terminalParametersMap()[terminalParameterKeys.CSH_PRINT_RECEIPT] === terminalPrintReceiptParamValues.NOT_PRINT ? '1475px' : '1300px'"
  [compact]="true"
  (closed)="handleKeyboardClear()"
  class="summary-modal"
>
  <ng-template>
    @if (reservationsStore.rebookReservation()) {
      <app-content-box
        theme="orange"
      >
        <div class="d-flex align-items-center gap-8">
          <i class="ri-information-line"></i>
          {{ 'Reservation Rebook in Progress' | trans:'cart/summary-modal/reservation-rebook-info.Text' }}
        </div>
      </app-content-box>
    }

    <div class="d-flex m-t-8 gap-16 flex-grow-1" [class.disabled]="isCheckoutProcessing() || isCartFinishing()">
      <div class="d-flex flex-direction-column gap-16 flex-grow-1 left">
        @if (cartStore.cart().payments.length > 0) {
          <app-content-box
            theme="gray"
            class="d-flex flex-direction-column"
          >
            <h4 class="text-uppercase">{{ 'Transactions'| trans:'cart/summary-modal/transactions-section.Text' }}</h4>
            <table class="m-t-16">
              @for (payment of cartStore.cart().payments; track i; let i = $index; let last = $last) {
                <tr>
                  <td class="p-r-16 p2" [class.p-b-8]="!last">
                    {{ i + 1 }}.
                  </td>
                  <td class="p-r-16 p2" [class.p-b-8]="!last">
                    {{ payment.method }}
                  </td>
                  <td class="p-r-16 p2" [class.p-b-8]="!last">
                    {{ payment.amount | numberToCurrency }}  {{ languageConfig.currency.short }}
                  </td>
                  <td class="p-r-16" [class.p-b-8]="!last">
                    @switch (payment.status) {
                      @case (cartPaymentStatuses.Pending) {
                        <i class="ri-time-line c-t-warning-700 icon-xs"></i>
                      }

                      @case (cartPaymentStatuses.Rejected) {
                        <i class="ri-close-circle-line c-t-nok-500 icon-xs"></i>
                      }

                      @default {
                        <i class="ri-checkbox-circle-line c-t-ok-400 icon-xs"></i>
                      }
                    }
                  </td>

                  @if (cartStore.cart().status === cartStatuses.Pending && payment.method === cartPaymentMethods.Cash) {
                    <td [class.p-b-8]="!last">
                      <button
                        #btn
                        class="button button--icon-xs button--no-border c-t-nok-400"
                        (click)="removePayment(payment, btn)"
                        appTooltip
                        [delay]="tooltipDelay"
                        content="{{ 'Remove payment' | trans:'summary/payment/remove.Tooltip' }}"
                      >
                        <i class="ri-delete-bin-line"></i>
                      </button>
                    </td>
                  }
                </tr>
              }
            </table>
          </app-content-box>
        }

        <app-content-box
          theme="gray"
          class="flex-grow-1 d-flex flex-direction-column grow"
        >
          <div class="d-flex align-items-center justify-content-space-between gap-16 m-b-16">
            <h4 class="text-uppercase">{{ 'Cart'| trans:'cart/summary-modal/cart-section.Text' }}</h4>
          </div>

          <app-scrollable-wrapper>
            @if (cartStore.cart().items.length === 0) {
              <p>{{ 'Cart is empty.'| trans:'cart/summary-modal/empty.Text' }}</p>
            } @else {
              @if (cartStore.groupedCartItemsTickets().length > 0) {
                <div class="group">
                  <div class="d-flex flex-direction-column gap-16">
                    @for (item of cartStore.groupedCartItemsTickets(); track item.showId + '_' + item.showBegin + '_' + item.auditoriumName + '_' + item.cinemaName) {
                      @if (!paySeparatelyStore.isPaySeparatelyModeEnabled() || hasSelectedTicketsInGroup(item)) {
                        <ng-container [ngTemplateOutlet]="cartItemTicket" [ngTemplateOutletContext]="{ item }" />
                      }
                    }
                  </div>
                </div>
              }

              @if (cartStore.cartItemsProductsAndPackages().length > 0) {
                <div class="group">
                  <div class="d-flex flex-direction-column gap-8">
                    @for (item of cartStore.cartItemsProductsAndPackages(); track item.itemId + '_' + item.position) {
                      <ng-container [ngTemplateOutlet]="cartItemProduct" [ngTemplateOutletContext]="{ item }" />
                    }
                  </div>
                </div>
              }

              @if (cartStore.cartItemsVouchers().length > 0) {
                <div class="group">
                  <div class="d-flex flex-direction-column gap-8">
                    @for (item of cartStore.cartItemsVouchers(); track item.itemId + '_' + item.position) {
                      <ng-container [ngTemplateOutlet]="cartItemVoucher" [ngTemplateOutletContext]="{ item }" />
                    }
                  </div>
                </div>
              }

              @if (cartStore.cartItemsCashedVouchers().length > 0) {
                <div class="group">
                  <div class="d-flex flex-direction-column gap-8">
                    @for (item of cartStore.cartItemsCashedVouchers(); track item.itemId + '_' + item.position) {
                      <ng-container [ngTemplateOutlet]="cartItemVoucher" [ngTemplateOutletContext]="{ item }" />
                    }
                  </div>
                </div>
              }

              @if (cartStore.cartItemsCancelledTickets().length > 0) {
                <div class="group">
                  <div class="d-flex flex-direction-column gap-8">
                    @for (item of cartStore.cartItemsCancelledTickets(); track item.itemId + '_' + item.position) {
                      <ng-container [ngTemplateOutlet]="cartItemCancelTicketOrGood" [ngTemplateOutletContext]="{ item }" />
                    }
                  </div>
                </div>
              }

              @if (cartStore.cartItemsCancelledGoods().length > 0) {
                <div class="group">
                  <div class="d-flex flex-direction-column gap-8">
                    @for (item of cartStore.cartItemsCancelledGoods(); track item.itemId + '_' + item.position) {
                      <ng-container [ngTemplateOutlet]="cartItemCancelTicketOrGood" [ngTemplateOutletContext]="{ item }" />
                    }
                  </div>
                </div>
              }

              @if (cartStore.cartItemsCancelledVouchers().length > 0) {
                <div class="group">
                  <div class="d-flex flex-direction-column gap-8">
                    @for (item of cartStore.cartItemsCancelledVouchers(); track item.itemId + '_' + item.position) {
                      <ng-container [ngTemplateOutlet]="cartItemCancelTicketOrGood" [ngTemplateOutletContext]="{ item }" />
                    }
                  </div>
                </div>
              }

              @if (cartStore.cartItemsCards().length > 0) {
                <div class="group">
                  <div class="d-flex flex-direction-column gap-8">
                    @for (item of cartStore.cartItemsCards(); track item.itemId + '_' + item.position) {
                      <ng-container [ngTemplateOutlet]="cartItemCard" [ngTemplateOutletContext]="{ item }" />
                    }
                  </div>
                </div>
              }

              @if (cartStore.cartItemsCardPayments().length > 0) {
                <div class="group">
                  <div class="d-flex flex-direction-column gap-8">
                    @for (item of cartStore.cartItemsCardPayments(); track item.itemId + '_' + item.position) {
                      <ng-container [ngTemplateOutlet]="cartItemCardPayment" [ngTemplateOutletContext]="{ item }" />
                    }
                  </div>
                </div>
              }
            }
          </app-scrollable-wrapper>
        </app-content-box>

        <app-content-box theme="gray">
          <div class="d-flex gap-8">
            <button
              class="button button--quick-action button--quick-action--red w-0 flex-grow-1"
              width="187px"
              #btn
              (click)="clearCart(btn)"
              [disabled]="isCheckoutOrPartiallyPaid || isEcChargeConfirmed()"
            >
              <i class="ri-delete-bin-line"></i>
              {{ 'Clear cart'| trans:'cart/summary-modal/clear-cart.Button' }}
            </button>

            <button
              class="button button--quick-action w-0 flex-grow-1"
              (click)="close()"
              [disabled]="isCheckoutOrPartiallyPaid || isEcChargeConfirmed()"
            >
              <i class="ri-file-list-3-line"></i>
              {{ 'Continue shopping'| trans:'cart/summary-modal/continue-shopping.Button' }}
            </button>

            <button
              class="button button--quick-action full-width w-0 flex-grow-1"
              [appWebCashPermissionControl]="permissionKeys.WebCxCashSafes"
              [extraDisabled]="!terminalParametersMap()[terminalParameterKeys.CSH_SAFE_PORT] || isTerminalWithoutSafe"
              (click)="openSafe()"
            >
              <i class="ri-coin-line"></i>
              {{ 'Open safe'| trans:'cart/summary-modal/open-safe.Button' }}
            </button>

            @if (terminalParametersMap()[terminalParameterKeys.CSH_PRINT_RECEIPT] === terminalPrintReceiptParamValues.NOT_PRINT) {
              <button
                class="button button--quick-action w-0 flex-grow-1"
                [disabled]="!isCheckoutOrPartiallyPaid || isPrintLastReceiptLoading()"
                (click)="printLastReceipt()"
              >
                <i class="ri-bill-line"></i>
                {{ 'Kaufquittung drucken' | trans:'cart/summary-modal/print-receipt.Button' }}
              </button>
            }

            <button
              class="button button--quick-action w-0 flex-grow-1"
              [disabled]="!isCheckoutOrPartiallyPaid || isInvoicePayment || areOnlyReservations"
              (click)="customersSearchModalComponent.open()"
            >
              <i class="ri-article-line"></i>
              {{ 'Generate Invoice'| trans:'cart/summary-modal/generate-invoice.Button' }}
            </button>
          </div>
        </app-content-box>
      </div>

      <div class="d-flex flex-direction-column gap-16 right">
        <app-content-box theme="gray">
          <h4 class="text-uppercase m-b-16">{{ 'Value'| trans:'cart/summary-modal/value-section.Text' }}</h4>

          @if (paySeparatelyStore.isPaySeparatelyModeEnabled()) {
            <app-content-box theme="white" borderRadius="base-border-radius">
              <div class="t3 fw-medium c-t-gray-500 text-uppercase m-b-16">{{ 'Für diese Zahlung ausgewählt' | trans:'cart/summary-modal/selected-for-payment.Text' }}</div>
              <div class="d-flex align-items-center gap-16 c-t-primary-700">
                <div class="h2 fw-medium">{{ paySeparatelyStore.selectedItemsTotal() | numberToCurrency }}</div>
                <div class="h2 fw-medium">{{ languageConfig.currency.short }}</div>
              </div>
            </app-content-box>
          } @else {
            <app-content-box theme="white" borderRadius="base-border-radius">
              <div class="t3 fw-medium c-t-gray-500 text-uppercase m-b-16">{{ 'Total'| trans:'cart/summary-modal/total.Text' }}</div>
              <div class="d-flex align-items-center gap-16">
                <div class="h2 fw-medium">{{ cartStore.cart().totalPrice | numberToCurrency }}</div>
                <div class="h2 fw-medium">{{ languageConfig.currency.short }}</div>
              </div>
            </app-content-box>
          }

          <div class="d-flex gap-8 m-t-8">
            <div class="w-0 flex-grow-1">
              <app-content-box theme="white" borderRadius="base-border-radius">
                <div class="t3 fw-medium c-t-gray-500 text-uppercase m-b-16">{{ 'Paid'| trans:'cart/summary-modal/paid.Text' }}</div>
                <div class="d-flex align-items-center gap-16 c-t-ok-400">
                  <div class="h2 fw-medium">
                    {{ (cartStore.cart().paidAmount < 0 ? 0 : cartStore.cart().paidAmount) | numberToCurrency }}
                  </div>
                  <div class="h2 fw-medium">{{ languageConfig.currency.short }}</div>
                </div>
              </app-content-box>
            </div>

            @if (cartStore.cart().paidAmount < paySeparatelyStore.toPayAmount()) {
              <div class="w-0 flex-grow-1">
                <app-content-box theme="white" borderRadius="base-border-radius">
                  <div class="t3 fw-medium c-t-gray-500 text-uppercase m-b-16">
                    {{ paySeparatelyStore.isPaySeparatelyModeEnabled() ? ('To pay (selected)' | trans:'cart/summary-modal/to-pay-selected.Text') : ('To pay'| trans:'cart/summary-modal/to-pay.Text') }}
                  </div>
                  <div class="d-flex align-items-center gap-16 c-t-nok-500">
                    <div class="h2 fw-medium">{{ (paySeparatelyStore.toPayAmount() - cartStore.cart().paidAmount) | numberToCurrency }}</div>
                    <div class="h2 fw-medium">{{ languageConfig.currency.short }}</div>
                  </div>
                </app-content-box>
              </div>
            } @else {
              <div class="w-0 flex-grow-1">
                <app-content-box theme="white" borderRadius="base-border-radius">
                  <div class="t3 fw-medium c-t-gray-500 text-uppercase m-b-16">
                    {{ 'Rückgeld'| trans:'cart/summary-modal/moneyReturn.Text' }}
                  </div>
                  <div class="d-flex align-items-center gap-16 c-t-ok-400">
                    <div class="h2 fw-medium">
                      {{ paySeparatelyStore.isPaySeparatelyModeEnabled()
                      ? (paySeparatelyStore.refundAmount() | numberToCurrency)
                      : (cartStore.cart().remainingAmount | numberToCurrency) }}
                    </div>
                    <div class="h2 fw-medium">{{ languageConfig.currency.short }}</div>
                  </div>
                </app-content-box>
              </div>
            }
          </div>
        </app-content-box>
        <app-content-box
          theme="gray"
          class="d-flex flex-grow-1 flex-direction-column grow"
        >
          <h4 class="text-uppercase">{{ 'Payment'| trans:'cart/summary-modal/payment-section.Text' }}</h4>
          <div
            class="m-t-16"
            [class.disabled]="cartStore.cart().paidAmount >= paySeparatelyStore.toPayAmount()"
          >
            <app-content-editable-input
              class="full-width"
              (valueChange)="amountValue = $event"
            />
          </div>
          <div class="separator"></div>
          <app-keyboard
            [isSimple]="false"
            (clear)="handleKeyboardClear()"
            (deleteBack)="handleKeyboardDeleteBack()"
            (keyClick)="handleKeyboardKeyClick($event)"
            [class.disabled]="cartStore.cart().paidAmount >= paySeparatelyStore.toPayAmount()"
          />
          <div class="separator"></div>
          <div class="d-flex gap-8">
            @if (cartStore.cart().paidAmount < paySeparatelyStore.toPayAmount()) {
              <ng-template
                [ngTemplateOutlet]="paymentButtonTemplate"
                [ngTemplateOutletContext]="{ type: cartPaymentMethods.Cash, icon: 'ri-coin-line', disabled: isTerminalWithoutSafe }"
              />

              <ng-template
                [ngTemplateOutlet]="paymentButtonTemplate"
                [ngTemplateOutletContext]="{ type: cartPaymentMethods.Card, icon: 'ri-bank-card-2-line' }"
              />

              <ng-template
                [ngTemplateOutlet]="paymentButtonTemplate"
                [ngTemplateOutletContext]="{ type: cartPaymentMethods.Invoice, icon: 'ri-bill-line', disabled: cartStore.cart().payments.length > 0 }"
              />
            } @else {
              @if (cartStore.cart().status === cartStatuses.Pending) {
                <button
                  class="button button--quick-action button--quick-action--green flex-grow-1"
                  height="108px"
                  (click)="onCheckoutButtonClick()"
                >
                  <i class="ri-shopping-cart-line"></i>
                  @if (paySeparatelyStore.isPaySeparatelyModeEnabled()) {
                    {{ 'Auswahl bezahlen' | trans:'cart/summary-modal/pay-selected.Button' }}
                  } @else {
                    {{ 'Checkout'| trans:'cart/summary-modal/checkout.Button' }}
                  }
                </button>
              } @else if (cartStore.cart().status === cartStatuses.PartiallyPaid) {
                <button
                  class="button button--quick-action button--quick-action--green flex-grow-1"
                  height="108px"
                  (click)="continue()"
                >
                  <i class="ri-arrow-right-line"></i>
                  {{ 'Continue'| trans:'cart/summary-modal/continue.Button' }}
                </button>
              } @else {
                <button
                  class="button button--quick-action button--quick-action--blue flex-grow-1"
                  height="108px"
                  (click)="closeCart()"
                >
                  <i class="ri-close-circle-line"></i>
                  {{ 'Finish'| trans:'cart/summary-modal/finish.Button' }}
                </button>
              }
            }
          </div>
        </app-content-box>
      </div>
    </div>
  </ng-template>
</app-modal>

<ng-template #cartItemTicket let-item="item">
  <div class="d-flex flex-direction-column gap-8">
    <div class="d-flex align-items-center gap-16">
      <div class="p2 fw-semibold">
        {{ item.showTitle }}
      </div>
      <div class="p2">
        {{ item.showBegin | localeDatetimeFormat }}
      </div>

      @if (cartStore.showTicketCinemaName()) {
        <div class="p2">
          {{ item.cinemaName }}
        </div>
      }

      <div class="p2">
        {{ item.auditoriumName }}
      </div>
    </div>

    @for (ticket of item.tickets; track ticket.itemId + '_' + ticket.position) {
      @if (!paySeparatelyStore.isPaySeparatelyModeEnabled() || !paySeparatelyStore.isHidden(ticket.itemId, ticket.position)) {
        <div
          class="d-flex align-items-center gap-8 cart-item-wrapper"
        >
          <app-content-box
            theme="white"
            borderRadius="base-border-radius"
            [class.pay-separately-unselected]="paySeparatelyStore.isPaySeparatelyModeEnabled() && paySeparatelyStore.isHidden(ticket.itemId, ticket.position) && !isCartInFinishedState"
            padding="p-y-2 p-l-16 p-r-8"
            class="flex-grow-1"
          >
          <div class="d-flex align-items-center white-space-nowrap">
            <div class="d-flex align-items-center gap-16 m-r-24" width="160px">
              <div class="d-flex align-items-center gap-12 p2 flex-grow-1 w-0">
                <div>{{ 'Row'| trans:'cart/ticket/row.Label' }}</div>
                <div class="fw-semibold">{{ ticket.seatRow }}</div>
              </div>
              <div class="d-flex align-items-center gap-12 p2 flex-grow-1 w-0">
                <div>{{ 'Seat'| trans:'cart/ticket/seat.Label' }}</div>
                <div class="fw-semibold">{{ ticket.seatNr }}</div>
              </div>
            </div>
            <div class="flex-grow-1 m-r-32">
              @if (cartStore.cart().status === cartStatuses.Pending) {
                <app-chip
                  [withIcon]="false"
                  [value]="ticket.priceCategoryId"
                  [label]="ticket.priceCategoryToken || ticket.priceCategory"
                  [selected]="true"
                  [disabled]="false"
                  (click)="isReservationTerminal ? null : priceCategoryPickerModalComponent.open({ ticket })"
                />
              } @else {
                {{ ticket.priceCategoryToken || ticket.priceCategory }}
              }
            </div>
            <div class="d-flex align-items-center justify-content-flex-end gap-16">
              <div class="white-space-nowrap">
                {{ ticket | cartItemDisplayTotal: cartStore.cart().discount: cartStore.cart().items | numberToCurrency }} {{ languageConfig.currency.short }}
              </div>

              @if (cartStore.cart().status === cartStatuses.Pending) {
                <button
                  #btn1
                  class="button button--icon-xs button--no-border c-t-nok-400"
                  (click)="removeItemFromCart(ticket.itemId, ticket.position, btn1)"
                  appTooltip
                  [delay]="tooltipDelay"
                  content="{{ 'Remove ticket' | trans:'summary/ticket/remove.Tooltip' }}"
                >
                  <i class="ri-delete-bin-line"></i>
                </button>
              }
            </div>
          </div>
        </app-content-box>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #cartItemProduct let-item="item">
  @for (_ of (paySeparatelyStore.isPaySeparatelyModeEnabled() ? (item.quantity | arrayByLength) : [1]); let index = $index; track index) {
    @if (!paySeparatelyStore.isPaySeparatelyModeEnabled() || !paySeparatelyStore.isHidden(item.itemId, item.position, index)) {
      <div class="d-flex align-items-center gap-8 cart-item-wrapper">
        <app-content-box
          theme="white"
          borderRadius="base-border-radius"
          padding="p-y-2 p-l-16 p-r-8"
          [class.pay-separately-unselected]="paySeparatelyStore.isPaySeparatelyModeEnabled() && paySeparatelyStore.isHidden(item.itemId, item.position, index) && !isCartInFinishedState"
          class="flex-grow-1"
        >
        <div class="d-flex align-items-center">
          <div
            class="d-flex align-items-center gap-16 m-r-24"
            [class.full-width]="!(item.itemType === cartItemTypes.Product || (item.itemType === cartItemTypes.Package && item.packageProducts.length === 0))"
            width="{{ (item.itemType === cartItemTypes.Product || (item.itemType === cartItemTypes.Package && item.packageProducts.length === 0)) ? '160px' : null }}"
          >
            <div class="d-flex gap-4 p2 flex-grow-1 w-0 flex-direction-column">
              <div>{{ item.name }}</div>
              @if (item.itemType === cartItemTypes.Package && item.packageProducts.length > 0) {
                <div class="p3 c-t-gray-600">
                  (@for (product of item.packageProducts; track product.id; let last = $last) {{{ product.name + (last ? '' : ', ') }}})
                </div>
              }
            </div>
          </div>

          @if (!paySeparatelyStore.isPaySeparatelyModeEnabled() && (item.itemType === cartItemTypes.Product || (item.itemType === cartItemTypes.Package && item.packageProducts.length === 0))) {
            <div class="flex-grow-1 m-r-32">
              @if (cartStore.cart().status === cartStatuses.Pending) {
                <app-stepper
                  [maxValue]="10000"
                  [(ngModel)]="item.quantity"
                  [disabled]="item.cardProductId"
                  (ngModelChange)="updateCartItem$.next(item)"
                />
              } @else {
                x {{ item.quantity }}
              }
            </div>
          }

          <div class="d-flex align-items-center justify-content-flex-end gap-16 to-right">
            <div class="white-space-nowrap">
              {{ (paySeparatelyStore.isPaySeparatelyModeEnabled() ? item.price : item.totalPrice) | numberToCurrency }} {{ languageConfig.currency.short }}
            </div>

            @if (cartStore.cart().status === cartStatuses.Pending) {
              <button
                #btn2
                class="button button--icon-xs button--no-border c-t-nok-400"
                (click)="removeOrDecreaseItemQuantity(item.itemId, item.position, btn2)"
                appTooltip
                [delay]="tooltipDelay"
                content="{{ 'Remove item' | trans:'summary/item/remove.Tooltip' }}"
              >
                <i class="ri-delete-bin-line"></i>
              </button>
            }
          </div>
        </div>
      </app-content-box>
      </div>
    }
  }
</ng-template>

<ng-template #cartItemVoucher let-item="item">
  @for (_ of (paySeparatelyStore.isPaySeparatelyModeEnabled() ? (item.quantity | arrayByLength) : [1]); let index = $index; track index) {
    @if (!paySeparatelyStore.isPaySeparatelyModeEnabled() || !paySeparatelyStore.isHidden(item.itemId, item.position, index)) {
      <div class="d-flex align-items-center gap-8 cart-item-wrapper">
        <app-content-box
          theme="white"
          borderRadius="base-border-radius"
          padding="p-y-2 p-l-16 p-r-8"
          [class.pay-separately-unselected]="paySeparatelyStore.isPaySeparatelyModeEnabled() && paySeparatelyStore.isHidden(item.itemId, item.position, index) && !isCartInFinishedState"
          class="flex-grow-1"
        >
        <div class="d-flex align-items-center">
          <div
            class="d-flex align-items-center gap-16 m-r-24"
            [class.full-width]="!(item | isVoucherStackable)"
            [width]="(item | isVoucherStackable) ? '160px' : null"
          >
            <div class="d-flex gap-4 p2 flex-grow-1 w-0 flex-direction-column">
              <div>{{ item.name }}</div>
            </div>
          </div>

          @if (!paySeparatelyStore.isPaySeparatelyModeEnabled() && (item | isVoucherStackable)) {
            <div class="flex-grow-1 m-r-32">
              @if (cartStore.cart().status === cartStatuses.Pending) {
                <app-stepper
                  [maxValue]="10000"
                  [(ngModel)]="item.quantity"
                  (ngModelChange)="updateCartItem$.next(item)"
                />
              } @else {
                x {{ item.quantity }}
              }
            </div>
          }

          <div class="d-flex align-items-center justify-content-flex-end gap-16 to-right">
            <div class="white-space-nowrap">
              {{ (paySeparatelyStore.isPaySeparatelyModeEnabled() ? item.price : item.totalPrice) | numberToCurrency }} {{ languageConfig.currency.short }}
            </div>

            @if (cartStore.cart().status === cartStatuses.Pending) {
              <button
                #btn3
                class="button button--icon-xs button--no-border c-t-nok-400"
                (click)="removeOrDecreaseItemQuantity(item.itemId, item.position, btn3)"
                appTooltip
                [delay]="tooltipDelay"
                content="{{ 'Remove voucher' | trans:'summary/voucher/remove.Tooltip' }}"
              >
                <i class="ri-delete-bin-line"></i>
              </button>
            }
          </div>
        </div>
      </app-content-box>
      </div>
    }
  }
</ng-template>

<ng-template #cartItemCancelTicketOrGood let-item="item">
  @if (!paySeparatelyStore.isPaySeparatelyModeEnabled() || !paySeparatelyStore.isHidden(item.itemId, item.position)) {
    <div
      class="d-flex align-items-center gap-8 cart-item-wrapper"
    >
      <app-content-box
        theme="white"
        borderRadius="base-border-radius"
        padding="p-y-2 p-l-16 p-r-8"
        class="flex-grow-1"
        [class.pay-separately-unselected]="paySeparatelyStore.isPaySeparatelyModeEnabled() && paySeparatelyStore.isHidden(item.itemId, item.position) && !isCartInFinishedState"
      >
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center gap-16 m-r-24 full-width">
          <div class="d-flex gap-4 p2 flex-grow-1 w-0 flex-direction-column">
            <div>{{ item.name }}</div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-flex-end gap-16 to-right">
          <div class="white-space-nowrap">
            {{ item.totalPrice | numberToCurrency }} {{ languageConfig.currency.short }}
          </div>

          @if (cartStore.cart().status === cartStatuses.Pending && !isCustomerScreen) {
            <button
              #btn4
              class="button button--icon-xs button--no-border c-t-nok-400"
              (click)="removeItemFromCart(item.itemId, item.position, btn4)"
              appTooltip
              [delay]="tooltipDelay"
              content="{{ 'Remove item' | trans:'summary/item/remove.Tooltip' }}"
            >
              <i class="ri-delete-bin-line"></i>
            </button>
          }
        </div>
      </div>
    </app-content-box>
    </div>
  }
</ng-template>

<ng-template #cartItemCard let-item="item">
  @if (!paySeparatelyStore.isPaySeparatelyModeEnabled() || !paySeparatelyStore.isHidden(item.itemId, item.position)) {
    <div
      class="d-flex align-items-center gap-8 cart-item-wrapper"
    >
      <app-content-box
        theme="white"
        borderRadius="base-border-radius"
        padding="p-y-2 p-l-16 p-r-8"
        class="flex-grow-1"
        [class.pay-separately-unselected]="paySeparatelyStore.isPaySeparatelyModeEnabled() && paySeparatelyStore.isHidden(item.itemId, item.position) && !isCartInFinishedState"
      >
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center gap-16 m-r-24 full-width">
          <div class="d-flex gap-4 p2 flex-grow-1 w-0 flex-direction-column">
            <div>{{ item.name }}</div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-flex-end gap-16 to-right">
          <div class="white-space-nowrap">
            {{ item.totalPrice | numberToCurrency }} {{ languageConfig.currency.short }}
          </div>

          @if (cartStore.cart().status === cartStatuses.Pending) {
            <button
              #btn5
              class="button button--icon-xs button--no-border c-t-nok-400"
              (click)="removeItemFromCart(item.itemId, item.position, btn5)"
              appTooltip
              [delay]="tooltipDelay"
              content="{{ 'Remove card' | trans:'summary/card/remove.Tooltip' }}"
            >
              <i class="ri-delete-bin-line"></i>
            </button>
          }
        </div>
      </div>
    </app-content-box>
    </div>
  }
</ng-template>

<ng-template #cartItemCardPayment let-item="item">
  @if (!paySeparatelyStore.isPaySeparatelyModeEnabled() || !paySeparatelyStore.isHidden(item.itemId, item.position)) {
    <div
      class="d-flex align-items-center gap-8 cart-item-wrapper"
    >
      <app-content-box
        theme="white"
        borderRadius="base-border-radius"
        padding="p-y-2 p-l-16 p-r-8"
        class="flex-grow-1"
        [class.pay-separately-unselected]="paySeparatelyStore.isPaySeparatelyModeEnabled() && paySeparatelyStore.isHidden(item.itemId, item.position) && !isCartInFinishedState"
      >
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center gap-16 m-r-24 full-width">
          <div class="d-flex gap-4 p2 flex-grow-1 w-0 flex-direction-column">
            <div>{{ item.name }}</div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-flex-end gap-16 to-right">
          <div class="white-space-nowrap">
            {{ item.totalPrice | numberToCurrency }} {{ languageConfig.currency.short }}
          </div>

          @if (cartStore.cart().status === cartStatuses.Pending) {
            <button
              #btn6
              class="button button--icon-xs button--no-border c-t-nok-400"
              (click)="detachCard(item.cardId)"
              appTooltip
              [delay]="tooltipDelay"
              content="{{ 'Detach card payment' | trans:'summary/card-payment/detach.Tooltip' }}"
            >
              <i class="ri-delete-bin-line"></i>
            </button>
          }
        </div>
      </div>
    </app-content-box>
    </div>
  }
</ng-template>

<ng-template #paymentButtonTemplate let-type="type" let-icon="icon" let-disabled="disabled">
  <app-payment-button
    class="payment-button"
    [disabled]="(contentEditableInputComponent && !(contentEditableInputComponent.value | fromCurrency) && type === cartPaymentMethods.Cash || disabled || isPaymentAdding() || isReservationTerminal) || (type === cartPaymentMethods.Card && ((!terminalParametersMap()[terminalParameterKeys.CASH_EC_TERMINAL_IP] && !isEcStandalone && !isEcSumUp) || isSumUpCardBlocked)) || (terminalsStore.arePaymentMethodsRestricted() && !terminalsStore.allowedPaymentMethodsMap()[type])"
    [type]="type"
    [icon]="icon"
    (paymentClick)="choosePayment($event)"
  />
</ng-template>

<app-payment-method-picker-modal
  [showVoucherOutOption]="showVoucherOutOption"
  (onOpen)="refundCartPaymentMethod = cartPaymentMethods.Cash; refundCardCode = null;"
  #paymentMethodPickerModalComponent
  (confirm)="refundCartPaymentMethod = $event.cartPaymentMethod; $event.cartPaymentMethod === cartPaymentMethods.CustomerCard ? cardCodeInputModalComponent.open(null, 'return-on-card') : $event.cartPaymentMethod === cartPaymentMethods.Invoice ? customersSearchModalComponent.open() : confirmRefundCartPaymentMethod();"
/>

<app-description-modal
  #descriptionModalComponent
  (confirm)="confirmDescription($event)"
/>

<app-reservation-customer-name-modal
  (onOpen)="customerName = null; reservationCode = null;"
  #reservationCustomerNameModalComponent
  (confirm)="customerName = $event.customerName; reservationCode = $event.reservationCode; checkoutCart();"
/>

<app-price-category-picker-modal #priceCategoryPickerModalComponent />

<app-card-code-input-modal
  #cardCodeInputModalComponent
  (codeSubmitted)="refundCardCode = $event.code; confirmRefundCartPaymentMethod(); cardCodeInputModalComponent.close();"
/>

<app-customers-search-modal
  [showAnonymButton]="true"
  #customersSearchModalComponent
  (confirmCustomerSelection)="selectedCustomerForInvoice = $event; refundCartPaymentMethod === cartPaymentMethods.Invoice ? confirmRefundCartPaymentMethod() : isCheckoutOrPartiallyPaid ? generateInvoice(true) : choosePayment(cartPaymentMethods.Invoice)"
  (dismissed)="cancelQuickInvoice()"
/>

<app-pdf-viewer-modal #pdfViewerModalComponent />

<app-ec-terminal-action-logs-modal
  #ecTerminalActionLogsModalComponent
/>
